// extracted by mini-css-extract-plugin
export default {"container":"MainWithdrawalFees_container__E55ax"};